import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import {
  promoLinksActions,
  promoLinksFormSelector,
  promoLinksSelector,
} from '$store/promoLinks/index';
import { t } from '$translation/helper';
import { Api } from '$api';
import { toastActions } from '$store/toast';
import { DeletePromoLinkAction, PromoLinksState } from '$store/promoLinks/interface';
import { goBack } from '$navigation/helper';

function* loadLinksWorker() {
  try {
    yield put(promoLinksActions.setIsLinksLoading(true));
    const data = yield call(Api.get, '/promo/links', {});
    yield put(promoLinksActions.setLinks(data.links));
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  } finally {
    yield put(promoLinksActions.setIsLinksLoading(false));
  }
}

function* createPromoLinkWorker() {
  const form: PromoLinksState['form'] = yield select(promoLinksFormSelector);
  yield put(toastActions.setToastLoading());
  try {
    const data = yield call(Api.post, '/promo/links/create', form);
    yield put(promoLinksActions.addLink(data.link));
    yield put(toastActions.setToastSuccess());
    yield call(goBack);
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* editPromoLinkWorker() {
  const { form, editingId }: PromoLinksState = yield select(promoLinksSelector);
  if (!editingId) {
    yield put(
      toastActions.setToastFail(
        t('failed_title', { defaultValue: 'Something went wrong' }),
      ),
    );
    return;
  }
  yield put(toastActions.setToastLoading());
  try {
    const data = yield call(Api.post, `/promo/links/${editingId}/edit`, form);
    yield put(promoLinksActions.updateLink(data.link));
    yield put(toastActions.setToastSuccess());
    yield call(goBack);
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* deletePromoLinkWorker(action: DeletePromoLinkAction) {
  const id = action.payload;
  yield put(toastActions.setToastLoading());
  try {
    yield call(Api.post, `/promo/links/${id}/delete`);
    yield put(promoLinksActions.removePromoLink(id));
    yield put(
      toastActions.setToastSuccess(
        t('promo_links_toast_deleted', { defaultValue: 'Link deleted' }),
      ),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

export function* promoLinksSaga() {
  yield all([
    takeEvery(promoLinksActions.loadLinks, loadLinksWorker),
    takeEvery(promoLinksActions.createPromoLink, createPromoLinkWorker),
    takeEvery(promoLinksActions.editPromoLink, editPromoLinkWorker),
    takeEvery(promoLinksActions.deletePromoLink, deletePromoLinkWorker),
  ]);
}
